<template>
  <div class="s-topic-rank img-bg" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <div :style="selfRechargeStyle.style">{{this.selfRecharge}}</div>
    <div :style="selfRankStyle.style">{{this.selfRank}}</div>
    <div v-for="(item,index) in recharge" :key="'name-'+index" :style="{...btnNameList[index]}" class="recharge_role_name">
      <div :style="index < 3 ? nameTextStyleObject : totalTextStyleObject">{{item.role_name}}</div>
    </div>
    <div v-for="(item,index) in recharge" :key="'rank-'+index" :style="{...btnRankList[index]}" class="recharge_value">
      <div :style="index < 3 ? valueTextStyleObject : totalTextStyleObject">{{item.value}}</div>
    </div>
  </div>
</template>

<script>
import SAnimateImage from "@/components/BuilderComponents/AnimateImage/index.vue";

export default {
  name: 'SVersionRank',
  components: { SAnimateImage },
  props: {
    keyword: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    selfRechargeStyle: {
      type: Object,
      required: true
    },
    selfRankStyle: {
      type: Object,
      required: true
    },
    btnNameList: {
      type: Array,
      required: true
    },
    btnRankList: {
      type: Array,
      required: true
    },
    nameTextStyle: {
      type: String,
      required: true
    },
    valueTextStyle: {
      type: String,
      required: true
    },
    totalTextStyle: {
      type: String,
      required: true
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    nameTextStyleObject () {
      try {
        return JSON.parse(this.nameTextStyle)
      } catch (e) {
        console.error('nameTextStyle 格式错误')
        return {}
      }
    },
    valueTextStyleObject () {
      try {
        return JSON.parse(this.valueTextStyle)
      } catch (e) {
        console.error('valueTextStyle 格式错误')
        return {}
      }
    },
    totalTextStyleObject () {
      try {
        return JSON.parse(this.totalTextStyle)
      } catch (e) {
        console.error('totalTextStyle 格式错误')
        return {}
      }
    }
  },
  data () {
    return {
      recharge: [],
      selfRank: 0,
      selfRecharge: {}
    }
  },
  mounted () {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getRankAct)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
    this.getRankAct()
  },
  methods: {
    // 重置
    reset () {
      this.getRankAct()
    },
    // 获取排行榜信息
    getRankAct () {
      this.requestAPI({
        url: '/v1/official/act-rank',
        method: 'get',
        params: { keyword: this.keyword, count: 10 }
      }).then((res) => {
        this.recharge = res.recharge
        this.selfRank = res.self_rank === 0 ? '未上榜' : res.self_rank
        this.selfRecharge = res.self_recharge.value ? res.self_recharge.value : 0
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.img-bg{
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.s-topic-rank{
  position: relative;
  .recharge_role_name, .recharge_value{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 52px;
  }
}
</style>
